<template>
    <div class="ui modal">
        <i class="close icon"></i>
        <div class="header">
            An error occured
        </div>
        <div class="content">
            <pre>{{ JSON.stringify(error, null, 2) }}</pre>
        </div>
        <div class="actions">
            <div class="ui ok button">
                Ok
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'error-modal',

  props: ['error'],

  methods: {
    show() {
      $(this.$el).modal('show');
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/ErrorModal.vue